module.exports = __webpack_public_path__ + "static/media/image2.feb9e97b.jpg";